// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"style_avatarContainer__3czfn"};